import { errorHandler } from "@/services/toastHandler";

const SETTING = { section: "system", key: "bonus-bet-token-symbol" };

const bonusBetTokenSymbolModule = {
  namespaced: true,
  state: {
    loading: false,
    saving: false,
  },
  mutations: {
    LOADING: (s, data) => (s.loading = data),
    SAVING: (s, data) => (s.saving = data),
  },
  actions: {
    async getBonusBetTokenSymbol({ commit }) {
      commit("LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/settings/detail", {
          params: SETTING,
        });
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING", false);
      }
    },
    // value is a plain JSON string, e.g. "USDC"
    async updateBonusBetTokenSymbol({ commit }, symbol) {
      commit("SAVING", true);
      try {
        const res = await this.$api.post("/v1/portal/settings/update", {
          ...SETTING,
          value: symbol,
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SAVING", false);
      }
    },
  },
};

export default bonusBetTokenSymbolModule;
